/**
 * Which Crosbe logo the sidebar shows, by rail colour and width.
 *
 * The rail is either light (the plain light theme) or dark (dark mode, either
 * navy theme, or the vibrant theme's navy sidebar). Each width has one asset per
 * rail colour:
 *   - expanded: the wordmark, white on a dark rail, navy on a light one (Jez 15 Jul).
 *   - collapsed: the mark alone. The full-colour mark is navy and light blue, and
 *     its navy half vanishes on a dark rail, so a dark rail takes the white and
 *     light-blue mark cropped from the official white wordmark (#3703, Jez 30 Sep).
 *
 * One pure function so the Sidebar and its test read the same rule.
 */
import type { AppThemeFlags } from "@/lib/themes";

export const RAIL_LOGO = {
  wordmarkOnDark: "/crosbe-wordmark-white.png",
  wordmarkOnLight: "/crosbe-wordmark-navy.png",
  markOnDark: "/crosbe-mark-white.png",
  markOnLight: "/crosbe-logo.png",
} as const;

/** Every theme whose sidebar is navy. */
export function isNavyRail(appThemes: AppThemeFlags): boolean {
  return (
    appThemes.crosbeNavy1 === true ||
    appThemes.crosbeNavy2 === true ||
    appThemes.crosbeBrand1 === true
  );
}

/** A dark rail: dark mode, or any navy sidebar theme. */
export function isDarkRail(theme: string, appThemes: AppThemeFlags): boolean {
  return theme === "dark" || isNavyRail(appThemes);
}

export function railLogoSrc(opts: { collapsed: boolean; darkRail: boolean }): string {
  if (opts.collapsed) return opts.darkRail ? RAIL_LOGO.markOnDark : RAIL_LOGO.markOnLight;
  return opts.darkRail ? RAIL_LOGO.wordmarkOnDark : RAIL_LOGO.wordmarkOnLight;
}
